import { signUpSteps } from "../../authHelpers";
import { t } from "@lingui/core/macro";

export const signUpInfoData = (isMobileActive, memberKeyLabel, isStandaloneTravel) => {
  return {
    [signUpSteps.GENERAL]: {
      header: t`Sign up to start saving!`,
      bulletPoints: isStandaloneTravel
        ? [
            t`Special member-only pricing`,
            t`Save up to 50%`,
            t`Free cancellation at most locations`,
            t`Pay now or pay later car rentals`,
            t`Safe and secure booking`,
          ]
        : [
            t`Because who likes to pay full price on anything?`,
            t`Access to our privately negotiated discounts`,
            ...(isMobileActive ? [t`Easily find discounts with our popular mobile app`] : []),
            t`Save up to 50% on everyday items`,
          ],
    },
    [signUpSteps.EMAIL]: {
      header: t`Why should I enter my email?`,
      bulletPoints: [
        t`Your email is unique to you, and we use it as your login credential`,

        t`You'll be the first to know about local offers and unique savings (<i>When you opt in</i>)`,

        t`You will be the first to know about special discounts near you`,
      ],
    },
    [signUpSteps.NAME]: {
      header: t`Why do we need your real name?`,
      bulletPoints: [
        t`Verify that you are authorized to register for this exclusive discount network`,
        t`Confirm your identity so we can prevent misuse`,
        t`Make sure you're a human and not a robot`,
      ],
    },
    [signUpSteps.PASSWORD]: {
      header: t`Password tips`,
      bulletPoints: [
        t`Add more characters: Longer passwords are more secure`,
        t`Use phrases: Harder to crack and easier to remember`,
        t`Avoid the obvious: Steer clear of common words or names`,
      ],
    },
    [signUpSteps.MEMBER_ID]: {
      header: memberKeyLabel
        ? t`What is my <div>${memberKeyLabel}</div>`
        : t`What is my <div>member ID?</div>`,
      bulletPoints: [
        t`Provided by your sponsoring program or organization`,
        t`Adds an additional layer of security to keep out unauthorized users`,
      ],
    },
    [signUpSteps.REGISTRATION_CODE]: {
      header: memberKeyLabel
        ? t`What is my <div>${memberKeyLabel}</div>`
        : t`What is my <div>registration code?</div>`,
      bulletPoints: [
        t`Provided by your sponsoring program or organization`,
        t`Adds an additional layer of security to keep out unauthorized users`,
      ],
    },
  };
};
